export enum AcceptedFileType {
    IMAGE = 'image/jpeg, image/png',
    TEXT = 'text/plain',
    JSON = 'application/json'
}